<template>
  <v-container grid-list-xl>
    <v-card>
      <v-toolbar flat color="red lighten-5">
        <v-icon left color="red darken-3">local_shipping</v-icon>
        <v-toolbar-title class="font-weight-bold red--text text--darken-3">Teslimat Gecikmeleri</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-chip color="red darken-2" text-color="white" small label>Geciken {{ result.delayed.length }}</v-chip>
        <v-chip color="orange darken-2" text-color="white" small label>Geç Teslim {{ result.lateDelivered.length }}</v-chip>
      </v-toolbar>

      <v-layout wrap align-center class="px-3 pt-3">
        <v-flex xs12 sm3 class="px-2">
          <v-menu v-model="menu1" :close-on-content-click="false" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="startDate" label="Gönderim Baş. Tarihi" prepend-icon="event" readonly v-on="on" hide-details></v-text-field>
            </template>
            <v-date-picker v-model="startDate" locale="tr-TR" @input="menu1 = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm3 class="px-2">
          <v-menu v-model="menu2" :close-on-content-click="false" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="endDate" label="Gönderim Bit. Tarihi" prepend-icon="event" readonly v-on="on" hide-details></v-text-field>
            </template>
            <v-date-picker v-model="endDate" locale="tr-TR" @input="menu2 = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm3 class="px-2">
          <v-text-field v-model="search" label="Ara (sipariş no / müşteri / şehir)" prepend-icon="search" clearable hide-details></v-text-field>
        </v-flex>
        <v-flex xs12 sm3 class="px-2">
          <v-btn color="red darken-2" dark :loading="loading" @click="load">
            <v-icon left>filter_list</v-icon>Listele
          </v-btn>
        </v-flex>
      </v-layout>

      <v-alert v-if="result.unmatchedCityCount > 0" :value="true" type="info" outline class="mx-3 mt-2">
        {{ result.unmatchedCityCount }} sipariş, teslim şehri "Teslim Süreleri" tablosunda tanımlı olmadığı için hesaplanamadı.
      </v-alert>

      <v-tabs v-model="innerTab" color="white" slider-color="red darken-2" class="mt-2">
        <v-tab>Teslimatı Gecikenler ({{ filteredDelayed.length }})</v-tab>
        <v-tab>Geç Teslim Edilmiş Siparişler ({{ filteredLate.length }})</v-tab>
      </v-tabs>

      <v-tabs-items v-model="innerTab">
        <v-tab-item>
          <v-data-table :headers="delayedHeaders" :items="filteredDelayed" :loading="loading" :rows-per-page-items="[25, 50, 100, { text: 'Tümü', value: -1 }]" class="elevation-0 mt-2">
            <template v-slot:items="props">
              <td class="px-2">{{ formatDate(props.item.completedDate) }}</td>
              <td class="px-2">{{ formatDate(props.item.expectedDeliveryDate) }}</td>
              <td class="px-2 text-xs-center">
                <v-chip small color="red darken-2" text-color="white">{{ props.item.daysOverdue }} gün</v-chip>
              </td>
              <td class="px-2">{{ props.item.orderNumber || props.item.packageNumber || '-' }}</td>
              <td class="px-2">{{ props.item.recipientName }}</td>
              <td class="px-2">{{ props.item.shippingCity }}</td>
              <td class="px-2">{{ props.item.productNames || '-' }}</td>
              <td class="px-2 text-xs-center">{{ props.item.quantity }}</td>
              <td class="px-2 text-xs-right">{{ formatMoney(props.item.totalAmount) }} ₺</td>
            </template>
            <template v-slot:no-data>
              <div class="pa-4 text-xs-center grey--text">{{ loading ? 'Yükleniyor...' : 'Teslimatı geciken sipariş yok.' }}</div>
            </template>
          </v-data-table>
        </v-tab-item>

        <v-tab-item>
          <v-data-table :headers="lateHeaders" :items="filteredLate" :loading="loading" :rows-per-page-items="[25, 50, 100, { text: 'Tümü', value: -1 }]" class="elevation-0 mt-2">
            <template v-slot:items="props">
              <td class="px-2">{{ formatDate(props.item.completedDate) }}</td>
              <td class="px-2">{{ formatDate(props.item.expectedDeliveryDate) }}</td>
              <td class="px-2">{{ formatDate(props.item.deliveredDate) }}</td>
              <td class="px-2 text-xs-center">
                <v-chip small color="orange darken-2" text-color="white">{{ props.item.daysLate }} gün</v-chip>
              </td>
              <td class="px-2">{{ props.item.orderNumber || props.item.packageNumber || '-' }}</td>
              <td class="px-2">{{ props.item.recipientName }}</td>
              <td class="px-2">{{ props.item.shippingCity }}</td>
              <td class="px-2">{{ props.item.productNames || '-' }}</td>
              <td class="px-2 text-xs-center">{{ props.item.quantity }}</td>
              <td class="px-2 text-xs-right">{{ formatMoney(props.item.totalAmount) }} ₺</td>
            </template>
            <template v-slot:no-data>
              <div class="pa-4 text-xs-center grey--text">{{ loading ? 'Yükleniyor...' : 'Geç teslim edilmiş sipariş yok.' }}</div>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      menu1: false,
      menu2: false,
      startDate: null,
      endDate: null,
      search: '',
      innerTab: 0,
      result: { delayed: [], lateDelivered: [], unmatchedCityCount: 0 },
    };
  },
  computed: {
    delayedHeaders() {
      return [
        { text: 'Gönderim', value: 'completedDate', sortable: true },
        { text: 'Beklenen Teslim', value: 'expectedDeliveryDate', sortable: true },
        { text: 'Gecikme', value: 'daysOverdue', sortable: true, align: 'center' },
        { text: 'Sipariş No', value: 'orderNumber', sortable: false },
        { text: 'Müşteri', value: 'recipientName', sortable: false },
        { text: 'Şehir', value: 'shippingCity', sortable: false },
        { text: 'Ürün', value: 'productNames', sortable: false },
        { text: 'Adet', value: 'quantity', sortable: false, align: 'center' },
        { text: 'Tutar', value: 'totalAmount', sortable: false, align: 'right' },
      ];
    },
    lateHeaders() {
      return [
        { text: 'Gönderim', value: 'completedDate', sortable: true },
        { text: 'Beklenen Teslim', value: 'expectedDeliveryDate', sortable: true },
        { text: 'Teslim Tarihi', value: 'deliveredDate', sortable: true },
        { text: 'Geç Kalma', value: 'daysLate', sortable: true, align: 'center' },
        { text: 'Sipariş No', value: 'orderNumber', sortable: false },
        { text: 'Müşteri', value: 'recipientName', sortable: false },
        { text: 'Şehir', value: 'shippingCity', sortable: false },
        { text: 'Ürün', value: 'productNames', sortable: false },
        { text: 'Adet', value: 'quantity', sortable: false, align: 'center' },
        { text: 'Tutar', value: 'totalAmount', sortable: false, align: 'right' },
      ];
    },
    filteredDelayed() {
      return this.applySearch(this.result.delayed);
    },
    filteredLate() {
      return this.applySearch(this.result.lateDelivered);
    },
  },
  methods: {
    applySearch(list) {
      const q = (this.search || '').trim().toLocaleLowerCase('tr');
      if (!q) return list;
      return list.filter((o) =>
        (o.orderNumber || '').toLocaleLowerCase('tr').includes(q)
        || (o.packageNumber || '').toLocaleLowerCase('tr').includes(q)
        || (o.recipientName || '').toLocaleLowerCase('tr').includes(q)
        || (o.shippingCity || '').toLocaleLowerCase('tr').includes(q));
    },
    async load() {
      this.loading = true;
      try {
        this.result = (await this.$store.dispatch('orders/getDeliveryDelays', {
          startDate: this.startDate,
          endDate: this.endDate,
        })) || { delayed: [], lateDelivered: [], unmatchedCityCount: 0 };
      } catch (e) {
        this.result = { delayed: [], lateDelivered: [], unmatchedCityCount: 0 };
      } finally {
        this.loading = false;
      }
    },
    formatDate(value) {
      if (!value) return '-';
      const d = new Date(value);
      if (isNaN(d.getTime())) return value;
      return d.toLocaleDateString('tr-TR');
    },
    formatMoney(value) {
      return (Number(value) || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
  },
  async mounted() {
    const today = new Date();
    const past = new Date();
    past.setDate(today.getDate() - 30);
    this.startDate = past.toISOString().substr(0, 10);
    this.endDate = today.toISOString().substr(0, 10);
    await this.load();
  },
};
</script>
